import { render } from "./CreateTaskGroup.vue?vue&type=template&id=5402c354"
import script from "./CreateTaskGroup.vue?vue&type=script&lang=js"
export * from "./CreateTaskGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__